import { gql } from "@apollo/client"

export const GET_PRODUCTS_FOR_CATEGORY = gql`
  query getProductQuery(
    $after: String
    $attributes: [AttributeInput]
    $categories: [ID]
    $search: String
    $productTypes: [ID]
    $numberOfItem: Int
  ) {
    products(
      first: $numberOfItem
      filter: {
        isPublished: true
        attributes: $attributes
        categories: $categories
        search: $search
        productTypes: $productTypes
      }
      after: $after
      sortBy: {direction: ASC, field: RATING}
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
          slug
          variants {
            metadata {
              key
              value
            }
          }
          metadata {
            key
            value
          }
          thumbnail(size: 512) {
            url
            alt
          }
          seoTitle
          seoDescription
          availableForPurchase

          isAvailableForPurchase
          pricing {
            onSale
            discount {
              net {
                amount
                currency
              }
            }
            priceRangeUndiscounted {
              start {
                gross {
                  amount
                }
              }
            }
            priceRange {
              start {
                gross {
                  amount
                  currency
                }
              }
            }
          }
          attributes {
            values {
              name
              slug
            }
            attribute {
              name
              slug
            }
          }
        }
      }
    }
  }
`

export const GET_PRODUCTS_FOR_COLLECTION = gql`
  query getProductQuery(
    $after: String
    $attributes: [AttributeInput]
    $collections: [ID]
    $search: String
    $numberOfItem: Int
  ) {
    products(
      first: $numberOfItem
      filter: {
        isPublished: true
        attributes: $attributes
        collections: $collections
        search: $search
      }
      after: $after
      sortBy: {direction: ASC, field: RATING}
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
          slug
          variants {
            metadata {
              key
              value
            }
          }
          metadata {
            key
            value
          }
          media{
            url
            alt
          }
          thumbnail(size: 512) {
            url
            alt
          }
          seoTitle
          seoDescription
          availableForPurchase

          isAvailableForPurchase
          pricing {
            onSale
            discount {
              net {
                amount
                currency
              }
            }
            priceRangeUndiscounted {
              start {
                gross {
                  amount
                }
              }
            }
            priceRange {
              start {
                gross {
                  amount
                  currency
                }
              }
            }
          }
          attributes {
            values {
              name
              slug
            }
            attribute {
              name
              slug
            }
          }
        }
      }
    }
  }
`
export const GET_CATEGORY_ATTACH_FROM_COLLECTION = gql`
query getCategoryAttach($categoryId: ID) {
  category(id: $categoryId) {
    name
    slug
    level
    parent {
      name
      slug
      parent {
        slug
        name
      }
    }
  }
}

`
